module.exports = __webpack_public_path__ + "img/01.750f03c5.png";